'use client';

import { useState } from 'react';
import { AppBar, Box, Toolbar, useTheme, useMediaQuery, IconButton, Drawer, List, ListItemText, ListItemButton, Divider, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { getAppBarStyles, toolbarStyles } from './styles/NavBarStyles';
import { NavBarLogo } from './components/NavBarLogo';
import { NavBarTitle } from './components/NavBarTitle';
import { NavButton } from './components/NavButton';
import { LogoutButton } from './components/LogoutButton';
import ThemeToggle from './components/ThemeToggle';
import { useNavBarCommon } from './hooks/useNavBarCommon';
import { useAppTheme } from '../../context/theme.context';

const NavBar = () => {
  const { currentUser, handleLogout, handleNavigate, isActive } = useNavBarCommon();
  const { colors, isDark, setThemeMode } = useAppTheme();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" sx={getAppBarStyles(colors)}>
        <Toolbar sx={toolbarStyles}>
          <NavBarLogo onHomeClick={() => handleNavigate('/')} />

          <NavBarTitle title={currentUser?.name} />

          {!isMobile ? (
            <>
              <NavButton
                label="Mis ofertas"
                onClick={() => handleNavigate('/my-offers')}
                isActive={isActive('/my-offers')}
              />

              <NavButton
                label="Favoritos"
                onClick={() => handleNavigate('/my-favorites')}
                isActive={isActive('/my-favorites')}
              />

              <NavButton
                label="Configuración"
                onClick={() => handleNavigate('/configuration')}
                isActive={isActive('/configuration')}
              />
            </>
          ) : (
            <IconButton
              color="inherit"
              onClick={() => setMobileMenuOpen(true)}
            >
              <MenuIcon />
            </IconButton>
          )}

          <ThemeToggle />
          <LogoutButton onLogout={handleLogout} />
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="right"
        open={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
        PaperProps={{
          sx: {
            width: 300,
            backgroundColor: colors.surface || '#fff',
            backgroundImage: 'none',
          },
        }}
      >
        {/* Drawer header */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 2,
            py: 2,
            background: colors.navBar?.gradient || colors.primary,
            color: '#fff',
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            {currentUser?.name || 'Menú'}
          </Typography>
          <IconButton size="small" onClick={() => setMobileMenuOpen(false)} sx={{ color: '#fff' }}>
            <CloseIcon />
          </IconButton>
        </Box>

        <List sx={{ pt: 1 }}>
          <ListItemButton onClick={() => { setMobileMenuOpen(false); handleNavigate('/'); }} sx={{ borderRadius: 2, mx: 1, mb: 0.5 }}>
            <ListItemText primary="Inicio" primaryTypographyProps={{ fontWeight: 600 }} />
          </ListItemButton>
          <ListItemButton onClick={() => { setMobileMenuOpen(false); handleNavigate('/my-offers'); }} sx={{ borderRadius: 2, mx: 1, mb: 0.5 }}>
            <ListItemText primary="Mis ofertas" />
          </ListItemButton>
          <ListItemButton onClick={() => { setMobileMenuOpen(false); handleNavigate('/my-favorites'); }} sx={{ borderRadius: 2, mx: 1, mb: 0.5 }}>
            <ListItemText primary="Favoritos" />
          </ListItemButton>
          <ListItemButton onClick={() => { setMobileMenuOpen(false); handleNavigate('/configuration'); }} sx={{ borderRadius: 2, mx: 1, mb: 0.5 }}>
            <ListItemText primary="Configuración" />
          </ListItemButton>
          <Divider sx={{ my: 1.5, mx: 2 }} />
          <ListItemButton onClick={() => { setThemeMode(isDark ? 'light' : 'dark'); }} sx={{ borderRadius: 2, mx: 1, mb: 0.5 }}>
            <ListItemText primary={isDark ? 'Modo claro' : 'Modo oscuro'} />
          </ListItemButton>
        </List>
      </Drawer>

    </Box>
  );
};

export default NavBar;
